const Module = () => import('./Module.vue')
const Overview = () => import('./views/Overview.vue')
const Distribute = () => import('./views/Distribute.vue')

const moduleRoute = {
  path: '/overview',
  component: Module,
  meta: {
    requiresAuth: true
  },
  children: [

    {
      name: 'Overview',
      path: ':page',
      component: Overview
    },
    {
      name: 'Distribute',
      path: ':page/:campaignId/distribute/:batteryId',
      component: Distribute,
      props: route => ({
        isQuestionnaire: (route.query.qst === 'true'),
        testBatteryId: route.params.batteryId,
        campaignId: route.params.campaignId
      })
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
